module.exports = __webpack_public_path__ + "static/flag-0027e3e0d115dbe737be04a24660e61a.svg";